<template>
  <v-dialog
    v-model="show"
    persistent
    @keydown.esc="hide"
    width="500"
    v-if="myRole('admin', 'departmentManager', 'safetyRepresentative')"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        small
        class="primary accent-4 white--text mr-2 my-1"
        data-test="change-role-button"
      >
        {{ $t("profile.assignment.changeRole") }}
      </v-btn>
    </template>

    <v-card data-test="change-role-dialog">
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t("profile.assignment.changeRole") }}
      </v-card-title>

      <v-card-text>
        <v-radio-group v-model="newRole">
          <template v-for="(allowed, r) in roles">
            <v-radio
              v-if="myRole(...allowed)"
              :key="r"
              :label="$t('role.' + r)"
              :value="r"
              data-test="change-role-dialog-radio"
            />
          </template>
        </v-radio-group>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">
          {{ $t("dialog.cancel") }}
        </v-btn>

        <v-btn
          color="primary"
          text
          @click="save"
          :disabled="!canSave"
          :loading="loading"
          data-test="change-role-dialog-change"
        >
          {{ $t("dialog.assign") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ChangeRoleQuery from "../graphql/ChangeRole.gql";
import { mapGetters } from "vuex";

export default {
  props: ["id", "role"],

  data() {
    return {
      show: false,
      roles: {
        employee: ["admin", "departmentManager", "safetyRepresentative"],
        manager: ["admin", "departmentManager", "safetyRepresentative"],
        departmentManager: ["admin", "safetyRepresentative"],
        safetyRepresentative: ["admin", "safetyRepresentative"],
        admin: ["admin", "safetyRepresentative"],
      },
      newRole: this.role,
      loading: false,
    };
  },

  computed: {
    ...mapGetters({ myRole: "role" }),
    canSave() {
      return this.newRole !== this.role;
    },
  },

  watch: {
    role() {
      this.newRole = this.role;
    },
  },

  methods: {
    hide() {
      this.show = false;
    },
    save() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ChangeRoleQuery,
          variables: {
            id: this.id,
            newRole: this.newRole,
          },
        })
        .then((res) => {
          this.$emit("update:role", res.data.employee.role);
          this.hide();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
